// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Routing
import {withRouter} from "react-router-dom";
// Translations
import {withTranslation} from "react-i18next";
// Components
import {Dialog, DialogContent} from "@material-ui/core";
import {Button} from "@components/Input";
// SVG
import {errorSvg} from "assets";
import {convertException, translate} from "vendor/application";

class Error extends Component {
    constructor(props) {
        super(props);
        this.state = {
            msg: ""
        };
    }

    componentDidMount() {
        this.handleMsg();
    }

    handleMsg = () => {
        const {message} = this.props;
        var ms;

        if (message && message.responseJSON && message.responseJSON.message) {
            ms = message.responseJSON.message;
        } else {
            ms = message;
        }

        this.setState({msg: ms, from: this.props.from});
    };

    render() {
        const {t} = this.props;
        return (
            this.state.msg &&
            <Dialog onClose={this.props.onClose} className="dialog_error" open={true}>
                <DialogContent>
                    <div className={"dialog"}>
                        <span className={"title"}>{translate("backend_errors.title", t)}</span>
                        <span className={"svg"}>{errorSvg()}</span>
                        <span className={"description"} dangerouslySetInnerHTML={{__html: translate(`backend_errors.${convertException(this.state.msg)}`, t)}} />
                        <div className={"button_position"}>
                            <Button id={"notify_button_error"} type={"normal_delete"} text={t("inputs:button.accept")}
                                onClick={(e) => this.props.onClose(e)}/>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const error = connect(
    mapStateToProps
)(Error);

export default withTranslation(["notifications", "inputs"])(withRouter(error));
